(() => {
  const config = document.currentScript?.dataset;
  if (!config) return;
  let fancyboxLoading;
  let fancyboxReady = false;

  function loadScript(url) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.append(script);
    });
  }

  function loadFancybox() {
    if (fancyboxReady) return Promise.resolve();
    if (fancyboxLoading) return fancyboxLoading;
    const styleLoading = new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = config.fancyboxStyle;
      link.onload = resolve;
      link.onerror = reject;
      document.head.append(link);
    });
    fancyboxLoading = Promise.all([styleLoading, loadScript(config.fancyboxScript)]).then(() => {
      window.Fancybox.bind('[data-fancybox]', {});
      fancyboxReady = true;
    }).catch((error) => {
      fancyboxLoading = undefined;
      throw error;
    });
    return fancyboxLoading;
  }

  if (/^#gallery-/.test(window.location.hash) && document.querySelector('[data-fancybox]')) {
    loadFancybox().catch(() => {});
  }

  document.addEventListener('pointerover', (event) => {
    if (event.target instanceof Element && event.target.closest('[data-fancybox]')) {
      loadFancybox().catch(() => {});
    }
  }, { passive: true });

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element && event.target.closest('[data-fancybox]');
    if (!target || fancyboxReady || event.button || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    loadFancybox().then(() => target.click()).catch(() => {
      if (target.href) window.location.assign(target.href);
    });
  }, true);

  let heidiLoading = false;
  function loadHeidi() {
    if (heidiLoading) return;
    heidiLoading = true;
    loadScript(config.heidipayScript).catch(() => { heidiLoading = false; });
  }
  function needsHeidi() {
    return [...document.querySelectorAll('[data-heylight="true"]')].some((node) => {
      const drawer = node.closest('cart-drawer');
      return !drawer || drawer.classList.contains('active');
    });
  }
  if (needsHeidi()) {
    loadHeidi();
  } else {
    const observer = new MutationObserver(() => {
      if (needsHeidi()) {
        loadHeidi();
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
})();
